/* SSC order tracking page (/pages/track). Talks to the ssc-track Worker,
   see SSC-catalog/workers/ssc-track/README.md for the contract. */
(function () {
  'use strict';
  var root = document.getElementById('ssc-track');
  if (!root) return;

  var WORKER = root.getAttribute('data-worker');
  var form = root.querySelector('.st-form');
  var orderInput = form.querySelector('[name="order"]');
  var emailInput = form.querySelector('[name="email"]');
  var button = form.querySelector('button');
  var errorBox = root.querySelector('.st-error');
  var result = root.querySelector('.st-result');
  var cancelledBox = root.querySelector('.st-cancelled');
  var journey = root.querySelector('.st-journey');
  var marker = root.querySelector('.st-marker');
  var fromLabel = root.querySelector('.st-from-label');
  var fromDetail = root.querySelector('[data-st-from]');
  var timeline = root.querySelector('.st-timeline');
  var shipmentsBox = root.querySelector('.st-shipments');
  var itemsList = root.querySelector('.st-items');

  var STAGES = [
    { key: 'received', kanji: '受', label: 'Order received', line: 'Mise en place. Your order is in the queue.' },
    { key: 'packed', kanji: '包', label: 'Packed', line: 'Wrapped tight, like a good maki.' },
    { key: 'shipped', kanji: '送', label: 'On the way', line: 'Rolling toward you with the carrier.' },
    { key: 'out_for_delivery', kanji: '配', label: 'Out for delivery', line: 'Last stretch to your door.' },
    { key: 'delivered', kanji: '着', label: 'Delivered', line: 'Itadakimasu. Enjoy it.' }
  ];
  var RANK = { received: 0, packed: 1, shipped: 2, out_for_delivery: 3, delivered: 4 };
  var MARKER_X = { received: 118, packed: 200, shipped: 470, out_for_delivery: 735, delivered: 892 };
  var STATUS_NOTE = {
    attempted_delivery: 'The carrier tried to deliver and will try again or hold the parcel at a pickup point. The carrier page has the details.',
    failure: 'The carrier reported a problem with this parcel. Open the carrier tracking for details, or write to us and we will chase it.'
  };
  var ERRORS = {
    no_match: 'We could not match that order number and email. Check the number in your confirmation email (just the digits is fine) and use the email you ordered with.',
    bad_request: 'That does not look like an order number and an email address. Try again.',
    rate_limited: 'Too many tries in a short time. Give it ten minutes and try again.',
    upstream: 'Our order system is not answering right now. Try again in a minute, or write to us.'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
  }
  function imgUrl(src) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
  function set(key, text) {
    var el = root.querySelector('[data-st="' + key + '"]');
    if (el) el.textContent = text || '';
  }
  function prettyCity(loc) {
    if (!loc) return '';
    if (loc.country === 'CZ') return 'Prague';
    if (loc.country === 'US') return loc.city || 'Las Vegas';
    return loc.city || loc.name || '';
  }

  function stageDates(data) {
    var dates = { received: data.order.placed_at };
    (data.shipments || []).forEach(function (s) {
      var r = RANK[s.stage];
      if (r >= 1 && (!dates.packed || s.created_at < dates.packed)) dates.packed = s.created_at;
      if (r >= 2 && (!dates.shipped || s.created_at < dates.shipped)) dates.shipped = s.created_at;
      if (r === 3) dates.out_for_delivery = s.updated_at;
      if (r === 4) dates.delivered = s.updated_at;
    });
    return dates;
  }

  function renderTimeline(stage, dates) {
    var rank = RANK[stage];
    timeline.innerHTML = STAGES.map(function (s, i) {
      var cls = i < rank ? 'is-done' : (i === rank ? 'is-active' : '');
      var date = dates[s.key] ? fmtDate(dates[s.key]) : (i > rank ? 'Pending' : '');
      return '<li class="' + cls + '"><span aria-hidden="true">' + s.kanji + '</span><b>' + s.label + '</b>' +
        '<small>' + esc(date) + '</small>' + (i === rank ? '<em>' + s.line + '</em>' : '') + '</li>';
    }).join('');
  }

  function renderShipments(data) {
    var ships = data.shipments || [];
    if (!ships.length) {
      var copy = data.order.fulfillment_status === 'partial'
        ? 'Part of this order is still being packed. You will get a shipping email with the tracking number as soon as it leaves.'
        : 'Your order is in the queue at the warehouse. You will get a shipping email with the tracking number as soon as it leaves.';
      shipmentsBox.innerHTML = '<div class="st-shipment"><div><h3>Being packed</h3><p>' + copy + '</p></div></div>';
      return;
    }
    shipmentsBox.innerHTML = ships.map(function (s, i) {
      var title = ships.length > 1 ? 'Parcel ' + (i + 1) + ' of ' + ships.length : 'Your parcel';
      var line = STAGES[RANK[s.stage]].label +
        (s.carrier ? ' with ' + esc(s.carrier) : '') +
        (s.from && prettyCity(s.from) ? ', shipped from ' + esc(prettyCity(s.from)) : '') +
        (s.updated_at ? '. Last update ' + fmtDate(s.updated_at) : '') + '.';
      var num = s.tracking_number ? '<p>Tracking number <code>' + esc(s.tracking_number) + '</code></p>' : '';
      var btn = s.tracking_url ? '<a class="sg-primary" href="' + esc(s.tracking_url) + '" target="_blank" rel="noopener">Open carrier tracking</a>' : '';
      var note = s.shipment_status && STATUS_NOTE[s.shipment_status] ? '<p class="st-note">' + STATUS_NOTE[s.shipment_status] + '</p>' : '';
      var items = s.items && s.items.length
        ? '<div class="st-shipment-items">In this parcel: ' + s.items.map(function (it) { return esc(it.quantity + ' x ' + it.title); }).join(', ') + '</div>'
        : '';
      return '<div class="st-shipment"><div><h3>' + title + '</h3><p>' + line + '</p>' + num + '</div>' + btn + note + items + '</div>';
    }).join('');
  }

  function renderItems(items) {
    itemsList.innerHTML = (items || []).map(function (it) {
      var img = it.image ? '<img src="' + esc(imgUrl(it.image)) + '" alt="" loading="lazy" width="44" height="44">' : '<span class="st-noimg"></span>';
      var name = it.handle ? '<a href="/products/' + esc(it.handle) + '">' + esc(it.title) + '</a>' : esc(it.title);
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '';
      return '<li>' + img + '<div><b>' + name + '</b>' + variant + '</div><span class="st-qty">x' + esc(it.quantity) + '</span></li>';
    }).join('');
  }

  function render(data) {
    var stage = data.stage;
    var cancelled = stage === 'cancelled';
    var first = (data.shipments || [])[0];
    var d = data.order.destination || {};

    set('name', data.order.name);
    set('method', data.order.shipping_method || '');
    set('placed', fmtDate(data.order.placed_at));
    set('status', cancelled ? 'Cancelled' : STAGES[RANK[stage]].label);
    set('status-sub', cancelled ? '' : (stage === 'received' ? 'In the queue' : (first && first.carrier) || ''));
    set('dest', d.city || d.country || 'Unknown');
    set('dest-sub', d.city ? d.country : '');

    cancelledBox.hidden = !cancelled;
    journey.hidden = cancelled;
    timeline.hidden = cancelled;
    shipmentsBox.hidden = cancelled;

    var fromCity = first && prettyCity(first.from);
    fromLabel.textContent = fromCity ? fromCity.toUpperCase() : 'OUR KITCHEN';
    fromDetail.textContent = fromCity ? 'From ' + fromCity : 'From our EU or US warehouse';

    renderItems(data.items);
    if (!cancelled) {
      renderTimeline(stage, stageDates(data));
      renderShipments(data);
      journey.classList.toggle('is-moving', stage === 'shipped' || stage === 'out_for_delivery');
    }

    result.hidden = false;
    if (!cancelled) {
      // Let the scene lay out first so the parcel animates from the warehouse.
      marker.style.transform = 'translate(118px, 170px)';
      void journey.offsetWidth;
      marker.style.transform = 'translate(' + MARKER_X[stage] + 'px, 170px)';
    }
    result.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function showError(msg) {
    errorBox.textContent = msg;
    errorBox.hidden = false;
    result.hidden = true;
  }

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var order = orderInput.value.trim();
    var email = emailInput.value.trim();
    if (!order || !email) { showError(ERRORS.bad_request); return; }
    errorBox.hidden = true;
    root.classList.add('st-loading');
    button.disabled = true;
    var label = button.textContent;
    button.textContent = 'Looking up';
    fetch(WORKER + '/lookup', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order: order, email: email })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) { showError(ERRORS[res.body && res.body.error] || ERRORS.upstream); return; }
        render(res.body);
        try { history.replaceState(null, '', '?order=' + encodeURIComponent(order.replace(/[^0-9]/g, ''))); } catch (e) {}
      })
      .catch(function () { showError(ERRORS.upstream); })
      .then(function () {
        root.classList.remove('st-loading');
        button.disabled = false;
        button.textContent = label;
      });
  });

  // Emails link here as /pages/track?order=1234. The customer still types the email.
  try {
    var q = new URLSearchParams(window.location.search).get('order');
    if (q && /^#?\d{1,8}$/.test(q)) { orderInput.value = q.replace('#', ''); emailInput.focus(); }
  } catch (e) {}
})();
